/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Dhruv's Portfolio",
  description:
    "A passionate individual who always thrives to learn and work on end to end products which develop sustainable and scalable AI solutions to create impact.",
  og: {
    title: "Dhruv Kothiya Portfolio",
    type: "website",
    url: "http://kd1903.github.io/",
  },
};

//Home Page
const greeting = {
  title: "Dhruv Kothiya",
  logo_name: "DhruvKothiya",
  nickname: "Machine Learning Engineer",
  subTitle:
    "A passionate individual who always thrives to learn and work on end to end products which develop sustainable and scalable AI Products and solutions to create impact.",
  resumeLink:
    "https://drive.google.com/file/d/1FL_wydnPF2SWCdw2goYAgZ1KKBx8TpcD/view?usp=sharing",
  portfolio_repository: "https://github.com/kd1903",
  githubProfile: "https://github.com/kd1903",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/ashutosh1919",
  // linkedin: "https://www.linkedin.com/in/ashutosh-hathidara-88710b138/",
  // gmail: "dhruv12kothiya@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/kd1903",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Github",
    link: "https://github.com/kd1903",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/dhruvkothiya/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  // {
  //   name: "YouTube",
  //   link: "https://youtube.com/c/DevSense19",
  //   fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
  //   backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  // },
  {
    name: "Gmail",
    link: "mailto:dhruv12kothiya@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Twitter",
    link: "https://twitter.com/kothiya_dhruv",
    fontAwesomeIcon: "fa-twitter", // Reference https://fontawesome.com/icons/twitter?style=brands
    backgroundColor: "#1DA1F2", // Reference https://simpleicons.org/?q=twitter
  },
  // {
  //   name: "Facebook",
  //   link: "https://www.facebook.com/laymanbrother.19/",
  //   fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
  //   backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  // },
  {
    name: "Instagram",
    link: "https://www.instagram.com/dhruv_kothiya_1903/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "Computer Vision",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Rich Experience of working with Computer Vision projects as well as optimizing and deploying on edge devices (Jetson) or server/cloud with container orchastration tools.",
        "⚡ Developing highly scalable production ready Computer Vision models for various use cases like Image Recognition, Object Detection, etc.",
        "       - Jewellery Recognition",
        "       - Fire Detection",
        "       - Number Plate Detection and Recognition",
        "       - Car Parking Slot Detection",
        "       - People Detection and Counting with Face Recognition",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Deeplearning",
          imageSrc: "deeplearning_ai_logo.png",
        },
      ],
    },
    {
      title: "Natural Language Processing (NLP)",
      fileName: "FullStackImg",
      skills: [
        "⚡ Worked on Language Understanding and Processing projects like",
        " - Extracting data (key-value pair) from semi structured documents like Invoices",
        " - Generation MCQs from given text/paragraph",
        " - Implementation of API as well as full stack application with Flask/Django frameworks",
        " - Dockerized container based Kubernetes deployment on on-prim server as well as cloud"
      ],
      softwareSkills: [
        // {
        //   skillName: "HTML5",
        //   fontAwesomeClassname: "simple-icons:html5",
        //   style: {
        //     color: "#E34F26",
        //   },
        // },
        // {
        //   skillName: "CSS3",
        //   fontAwesomeClassname: "fa-css3",
        //   style: {
        //     color: "#1572B6",
        //   },
        // },
        // {
        //   skillName: "Sass",
        //   fontAwesomeClassname: "simple-icons:sass",
        //   style: {
        //     color: "#CC6699",
        //   },
        // },
        // {
        //   skillName: "JavaScript",
        //   fontAwesomeClassname: "simple-icons:javascript",
        //   style: {
        //     backgroundColor: "#000000",
        //     color: "#F7DF1E",
        //   },
        // },
        // {
        //   skillName: "ReactJS",
        //   fontAwesomeClassname: "simple-icons:react",
        //   style: {
        //     color: "#61DAFB",
        //   },
        // },
        // {
        //   skillName: "NodeJS",
        //   fontAwesomeClassname: "simple-icons:node-dot-js",
        //   style: {
        //     color: "#339933",
        //   },
        // },
        // {
        //   skillName: "NPM",
        //   fontAwesomeClassname: "simple-icons:npm",
        //   style: {
        //     color: "#CB3837",
        //   },
        // },
        // {
        //   skillName: "Yarn",
        //   fontAwesomeClassname: "simple-icons:yarn",
        //   style: {
        //     color: "#2C8EBB",
        //   },
        // },
        // {
        //   skillName: "Gatsby",
        //   fontAwesomeClassname: "simple-icons:gatsby",
        //   style: {
        //     color: "#663399",
        //   },
        // },
        // {
        //   skillName: "Flutter",
        //   fontAwesomeClassname: "simple-icons:flutter",
        //   style: {
        //     color: "#02569B",
        //   },
        // },
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms like Azure and GCP",
        "⚡ Deploying deep learning models on cloud with Docker and Kubernetes",
        "⚡ Hosting and maintaining websites on virtual machine instances along with integration of databases",
        "⚡ Creating production level CI/CD pipelines using various tools like Jenkins, GitHub, GitHub Actions, Cloud(GCP, Azure, etc.)"
      ],
      softwareSkills: [
        {
          skillName: "GCP",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "Azure",
          fontAwesomeClassname: "simple-icons:microsoftazure",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#326CE5",
          },
        },
      ],
    },
    // {
    //   title: "UI/UX Design",
    //   fileName: "DesignImg",
    //   skills: [
    //     "⚡ Designing highly attractive user interface for mobile and web applications",
    //     "⚡ Customizing logo designs and building logos from scratch",
    //     "⚡ Creating the flow of application functionalities to optimize user experience",
    //   ],
    //   softwareSkills: [
    //     {
    //       skillName: "Adobe XD",
    //       fontAwesomeClassname: "simple-icons:adobexd",
    //       style: {
    //         color: "#FF2BC2",
    //       },
    //     },
    //     {
    //       skillName: "Figma",
    //       fontAwesomeClassname: "simple-icons:figma",
    //       style: {
    //         color: "#F24E1E",
    //       },
    //     },
    //     {
    //       skillName: "Adobe Illustrator",
    //       fontAwesomeClassname: "simple-icons:adobeillustrator",
    //       style: {
    //         color: "#FF7C00",
    //       },
    //     },
    //     {
    //       skillName: "Inkscape",
    //       fontAwesomeClassname: "simple-icons:inkscape",
    //       style: {
    //         color: "#000000",
    //       },
    //     },
    //   ],
    // },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/layman_brother/",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/layman_brother",
    },
    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://www.codechef.com/users/kd1903",
    },
    {
      siteName: "Codeforces",
      iconifyClassname: "simple-icons:codeforces",
      style: {
        color: "#1F8ACB",
      },
      profileLink: "http://codeforces.com/profile/layman_brother",
    },
    {
      siteName: "Hackerearth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754",
      },
      profileLink: "https://www.hackerearth.com/@ashutosh391",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/laymanbrother",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Shri S’ad Vidya Mandal Institute of Technology (SVMIT)",
      subtitle: "B.Tech. in Computer Science and Engineering",
      logo_path: "svmit.png",
      alt_name: "SVMIT, Bharuch",
      duration: "2018 - 2022",
      descriptions: [
        "⚡ I have studied basic software engineering subjects like DS, Algorithms, DBMS, OS, CA, AI etc.",
        "⚡ Apart from this, I have learned Machine Learning, IoT, etc.",
        "⚡ Worked on Home Automation project on Arduino and Raspberry PI with Machine Learning",
      ],
      website_link: "https://svmit.ac.in/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Generative AI with Large Language Models",
      subtitle: "- DeepLearning.AI",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/PLXN9DXD57U5",
      alt_name: "DAI - GenAILLM",
      color_code: "#ffffff",
    },
    {
      title: "Fundamentals of Deep Learning",
      subtitle: "- NVIDIA",
      logo_path: "nvidia_logo.png",
      certificate_link:
        "https://courses.nvidia.com/certificates/ccca276f7413416eac81f6496a832b1c/",
      alt_name: "NVIDIA - FDL",
      color_code: "#ffffff",
    },
    {
      title: "CV for Industrial  Inspection",
      subtitle: "- NVIDIA",
      logo_path: "nvidia_logo.png",
      certificate_link:
        "https://courses.nvidia.com/certificates/0a2595a2aeea4577a91b63efbf7544f7/",
      alt_name: "NVIDIA - CV",
      color_code: "#ffffff",
    },
    {
      title: "Model Parallalizm: building and deploying large NNs",
      subtitle: "- GCP Training",
      logo_path: "nvidia_logo.png",
      certificate_link:
        "https://courses.nvidia.com/certificates/593115604f2845e28d3a8a395defae81/",
      alt_name: "NVIDIA",
      color_code: "#ffffff",
    },
    {
      title: "Getting Started with Jetson Nano",
      subtitle: "- NVIDIA",
      logo_path: "nvidia_logo.png",
      certificate_link:
        "https://learn.next.courses.nvidia.com/certificates/ac2b61ad0c354b10b866b15e2b031387",
      alt_name: "NVIDIA",
      color_code: "#ffffff",
    },
    {
      title: "Azure AI Fundamentals",
      subtitle: "- Microsoft",
      logo_path: "microsoft_logo.png",
      certificate_link:
        "https://www.credly.com/badges/be960277-73cb-4b64-ade5-4aec3a94fcb1/public_url",
      alt_name: "Microsoft Azure",
      color_code: "#ffffff",
    },
    {
      title: "Tensorflow Developer",
      subtitle: "- DeepLearning.AI",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://coursera.org/share/91f59731b4c92bfec1d6375902226928",
      alt_name: "DeepLearning.AI",
      color_code: "#ffffff",
    },
    {
      title: "Python",
      subtitle: "- Hackerrank",
      logo_path: "hackerrank.png",
      certificate_link: "https://www.hackerrank.com/certificates/0c47ade2143a",
      alt_name: "Hackerrank",
      color_code: "#ffffff",
    },
    {
      title: "Machine Learning",
      subtitle: "- Perfect eLearning",
      logo_path: "perfectelearning.png",
      certificate_link: "https://perfectelearning.com/certificate/7dfb3a056b",
      alt_name: "Perfect eLearning",
      color_code: "#ffffff",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "I have worked with many evolving startups as ML Engineer, MLOps Engineer. I have also worked with some well established companies as Solutions Engineer. I'm tech-savvy and passionate about coding and programming.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      work: true,
      experiences: [
        {
          title: "Machine Learning Engineer",
          company: "Freelancer",
          company_url: "https://kd1903.github.io",
          logo_path: "freelancer-freelance-icon.png",
          duration: "Sep 2023 onwards",
          location: "Bangalore, Karnataka",
          description:
            "Working with multiple companies to transform their vision into reality with AI Applications." +
            "● MoEVing - India electrical vehicle number plate detection and recognition." +
            "● Drnko - Extracting tabular and non-tabular data from receipts with finetuned OCR-free Document Understanding" +
            "Transformer, resulting in a 35% increase in accuracy and a 70% reduction in running costs deployed Django API" +
            "on Cloud with Kubernetes and Docker." +
            "● Denoising satellite image data, Brain tumor classification using Vision Transformers (ViT), etc.",
          color: "#0879bf",
        },
        {
          title: "Solution Engineer",
          company: "NVIDIA",
          company_url: "https://www.nvidia.com/en-in/",
          logo_path: "nvidia_logo.png",
          duration: "Apr 2023 - Aug 2023",
          location: "Bangalore, Karnataka",
          description:
            "Engage with startups and provide AI accelerated solutions by understanding their products, requirements and business model" +
            "● Gained expertise in NVIDIA's software and hardware for AI workloads, GPUs, and AI frameworks." +
            "● Collaborated with ~20 startups to scale their AI-accelerated solutions with DeepStream, TensorRT, etc.",
          color: "#0879bf",
        },
        {
          title: "Machine Learning Engineer",
          company: "Samyak Infotch Pvt. Ltd.",
          company_url: "https://www.samyak.com/",
          logo_path: "samyak.png",
          duration: "Jul 2022 - Apr 2023",
          location: "Ahmedabad, Gujarat",
          description:
            "• latest worked on DevOps for a project deployment on Azure Kubernetes Service with CI/CD pipelines with Jenkins\n" +
            "• Have worked on several deep learning projects as below\n" +
            "• MCQs generation with GPT-3 - Trained LLM with GPU on cloud\n" +
            "• Invoice Data Extraction end to end application with UI, model training, API and optimization and deployment\n" +
            "• People counter on edge device - Jetson Nano\n" +
            "• Jewellery Recognition with feature extraction model with UI, Data Augmentation, model training and Deployment",
          color: "#9b1578",
        }
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Machine Learning Intern",
          company: "Samyak Infotch Pvt. Ltd.",
          company_url: "https://www.samyak.com/",
          logo_path: "samyak.png",
          duration: "Jan 2022 - Jun 2022",
          location: "Ahmedabad, Gujarat",
          description:
            "Worked on Recommendation System with ML team\n" +
            "• Market basket analysis with content and collaborative filtering\n" +
            "• Worked with Kubernetes and Docker for deployment on GKE\n" +
            "• Built backend for Data Extraction project in Python\n" +
            "• Done the basic projects with Deep Learning (CNN)",
          color: "#fc1f20",
        }
      ],
    },
    // {
    //   title: "Volunteerships",
    //   experiences: [
    //     {
    //       title: "Google Explore ML Facilitator",
    //       company: "Google",
    //       company_url: "https://about.google/",
    //       logo_path: "google_logo.png",
    //       duration: "June 2019 - April 2020",
    //       location: "Hyderabad, Telangana",
    //       description:
    //         "Explore Machine Learning (ML) is a Google-sponsored program for university students to get started with Machine Learning. The curriculum offers 3 tracks of ML Content (Beginner, Intermediate, Advanced) and relies on university student facilitators to train other students on campus and to build opensource projects under this program.",
    //       color: "#4285F4",
    //     },
    //     {
    //       title: "Microsoft Student Partner",
    //       company: "Microsoft",
    //       company_url: "https://www.microsoft.com/",
    //       logo_path: "microsoft_logo.png",
    //       duration: "Aug 2019 - May 2020",
    //       location: "Hyderabad, Telangana",
    //       description:
    //         "Microsoft Student Partner is a program for university students to lead the awareness and use of Cloud especially Azure tools in the development of their projects and startups. Under this program, I have organised hands on workshops and seminars to teach Cloud Computing concepts to students.",
    //       color: "#D83B01",
    //     },
    //     {
    //       title: "Mozilla Campus Captain",
    //       company: "Mozilla",
    //       company_url: "https://www.mozilla.org/",
    //       logo_path: "mozilla_logo.png",
    //       duration: "Oct 2019 - May 2020",
    //       location: "Kurnool, Andhra Pradesh",
    //       description:
    //         "My responsibility for this program was to create opensource environment in college and in the city. We have organised multiple hackathons on the problems collected by ordinary people from Kurnool city. We have build opensource community of our own college. The community is available at dsc_iiitdmk on github.",
    //       color: "#000000",
    //     },
    //     {
    //       title: "Developer Students Club Member",
    //       company: "DSC IIITDM Kurnool",
    //       company_url:
    //         "https://www.linkedin.com/company/developer-students-club-iiitdm-kurnool",
    //       logo_path: "dsc_logo.png",
    //       duration: "Jan 2018 - May 2020",
    //       location: "Kurnool, Andhra Pradesh",
    //       description:
    //         "We have well established developer club in college which is directly associated with Google Developers. We have developed many interdisciplinary projects under the membership of this club. We have organised workshops and activities on Android Application Development, Flutter and React JS.",
    //       color: "#0C9D58",
    //     },
    //     {
    //       title: "Developer Program Member",
    //       company: "Github",
    //       company_url: "https://github.com/",
    //       logo_path: "github_logo.png",
    //       duration: "July 2019 - PRESENT",
    //       location: "Work From Home",
    //       description:
    //         "I am actively contributing to many opensource projects. I have contributed to projects of organisations like Tensorflow, Uber, Facebook, Google, Scikit-learn, Kiwix, Sympy, Python, NVLabs, Fossasia, Netrack, Keras etc. These contributions include bug fixes, feature requests and formulating proper documentation for project.",
    //       color: "#181717",
    //     },
    //   ],
    // },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technologies and tools. My best experience is to create AI projects and deploy them as web applications using cloud infrastructure.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description:
    "I have worked on and published a few research papers and publications of my own.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
  //   {
  //     id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzQ=",
  //     name: "Artificial Intelligence Paper",
  //     createdAt: "2020-03-06T16:26:54Z",
  //     description: "Paper Written on Artificial Intelligence published in xyz ",
  //     url:
  //       "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
  //   },
  //   {
  //     id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzi=",
  //     name: "Artificial Intelligence Paper",
  //     createdAt: "2020-03-06T16:26:54Z",
  //     description: "Paper Written on Artificial Intelligence published in xyz ",
  //     url:
  //       "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
  //   },
  //   {
  //     id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNze=",
  //     name: "Artificial Intelligence Paper",
  //     createdAt: "2020-03-06T16:26:54Z",
  //     description: "Paper Written on Artificial Intelligence published in xyz ",
  //     url:
  //       "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
  //   },
  //   {
  //     id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzt=",
  //     name: "Artificial Intelligence Paper",
  //     createdAt: "2020-03-06T16:26:54Z",
  //     description: "Paper Written on Artificial Intelligence published in xyz ",
  //     url:
  //       "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
  //   },
  //   {
  //     id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzb=",
  //     name: "Artificial Intelligence Paper",
  //     createdAt: "2020-03-06T16:26:54Z",
  //     description: "Paper Written on Artificial Intelligence published in xyz ",
  //     url:
  //       "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
  //   },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "kd-profile-pic.png",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with ML, AI and Python Development.",
  },
  blogSection: {
    title: "Available to work",
    subtitle:
      "Available for developing AI/ML products to fuel startups or freelance projects, let's turn ideas into intelligent solutions together.",
    link: "https://drive.google.com/file/d/1aoZiFNxRp0ftgSOFE1TJ6_sxpimEtXmI/view?usp=sharing",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Current Address",
    subtitle:
      "AECS Layout, Marathahalli, Bangalore",
    locality: "AECS Layout",
    country: "IN",
    region: "Karnataka",
    postalCode: "560037",
    streetAddress: "",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://maps.app.goo.gl/G2N7KSuQ6nLHnhkU7",
  },
  phoneSection: {
    title: "Personal contact",
    subtitle: "7284807026",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
